<template>
    <div class="app-container">
      <!-- 顶部输入区域 -->
      <el-card style="margin-bottom: 16px;">
        <div slot="header">
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <span style="font-size: 16px; font-weight: 600;">vivo批量用户管理</span>
            <div style="display: flex; gap: 8px;">
              <el-button type="info" icon="el-icon-download" @click="handleDownloadTemplate">
                下载模板
              </el-button>
              <el-upload
                ref="uploadRef"
                :auto-upload="false"
                :show-file-list="false"
                accept=".xlsx,.xls"
                :on-change="handleExcelImport"
              >
                <el-button type="warning" icon="el-icon-upload2">导入Excel</el-button>
              </el-upload>
              <el-button type="primary" icon="el-icon-search" @click="handleBatchQuery" :loading="loading">
                批量查询
              </el-button>
            </div>
          </div>
        </div>
  
        <el-form :model="formData" label-width="80px">
          <el-form-item label="账户名">
            <el-input
              v-model="formData.idsnameText"
              type="textarea"
              :rows="10"
              placeholder="请输入 账户名，每行一个"
              clearable
            />
            <div style="margin-top: 4px; font-size: 12px; color: #909399;">
              每行一个 账户名，也可点击“导入Excel”自动识别第一列
            </div>
          </el-form-item>
        </el-form>
      </el-card>
  
      <!-- 查询结果表格 -->
      <el-card v-if="tableData.length > 0">
        <div slot="header">
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <span style="font-size: 16px; font-weight: 600;">
              查询结果（共 {{ tableData.length }} 条）
            </span>
            <div style="display: flex; gap: 8px;">
              <!-- <el-button type="success" icon="el-icon-plus" @click="handleAdd">新增记录</el-button> -->
              <el-button
                type="primary"
                icon="el-icon-edit"
                @click="handleBatchEdit"
                :disabled="selectedRows.length === 0"
              >
                批量编辑 (已选 {{ selectedRows.length }})
              </el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                @click="handleBatchDelete"
                :disabled="selectedRows.length === 0"
              >
                批量删除 (已选 {{ selectedRows.length }})
              </el-button>
            </div>
          </div>
        </div>
  
        <el-table
          ref="tableRef"
          v-loading="loading"
          :data="tableData"
          border
          stripe
          style="width: 100%;"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="idsname" prop="idsname" width="150" show-overflow-tooltip />
          <el-table-column label="用户名" prop="username" width="120" show-overflow-tooltip />
          <el-table-column label="别名" prop="twoname" width="120" show-overflow-tooltip />
          <el-table-column label="URL" prop="url" min-width="180" show-overflow-tooltip />
          <el-table-column label="曝光URL" prop="baoguangurl" min-width="180" show-overflow-tooltip />
          <el-table-column label="小说URL" prop="xiaoshuourl" min-width="180" show-overflow-tooltip />
          <el-table-column label="Token" prop="token" width="150" show-overflow-tooltip />
          <el-table-column label="ids" prop="ids" width="120" show-overflow-tooltip />
          <el-table-column label="计划名称" prop="planName" width="150" show-overflow-tooltip />
          <el-table-column label="内置RPK DeepLink" prop="builtInRpkDeepLink" min-width="200" show-overflow-tooltip />
          <el-table-column label="创意DeepLink" prop="adcreativedeeplink" min-width="200" show-overflow-tooltip />
         
        </el-table>
      </el-card>
  
      <el-empty v-if="!loading && tableData.length === 0 && hasQueried" description="暂无查询结果" />
  
      <!-- 批量编辑弹窗 -->
      <el-dialog
        title="批量编辑参数"
        :visible.sync="batchEditDialog.visible"
        width="1400px"
        :close-on-click-modal="false"
        @close="handleBatchEditDialogClose"
      >
        <!-- 弹窗内的 Excel 导入按钮 -->
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
          <div style="display: flex; gap: 8px;">
            <el-button type="info" icon="el-icon-download" @click="handleDownloadEditTemplate">
              下载编辑模板
            </el-button>
            <el-upload
              ref="editUploadRef"
              :auto-upload="false"
              :show-file-list="false"
              accept=".xlsx,.xls"
              :on-change="handleEditExcelImport"
            >
              <el-button type="warning" icon="el-icon-upload2">
                导入Excel填充参数
              </el-button>
            </el-upload>
          </div>
          <span v-if="editExcelMsg" style="color: #67c23a; font-size: 13px;">
            {{ editExcelMsg }}
          </span>
        </div>
  
        <!-- 弹窗内编辑表格 -->
        <el-table :data="batchEditDialog.data" border stripe style="width: 100%;">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column label="idsname" prop="idsname" width="150" align="center" />
          <el-table-column label="用户名" width="120" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.username" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="别名" width="120" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.twoname" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="URL" min-width="180" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.url" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="曝光URL" min-width="180" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.baoguangurl" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="小说URL" min-width="180" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.xiaoshuourl" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="Token" min-width="150" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.token" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="ids" width="120" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.ids" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="计划名称" min-width="150" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.planName" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="内置RPK DeepLink" min-width="200" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.builtInRpkDeepLink" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="创意DeepLink" min-width="200" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.adcreativedeeplink" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
        </el-table>
  
        <div slot="footer">
          <el-button @click="batchEditDialog.visible = false">取消</el-button>
          <el-button type="primary" @click="handleSaveBatchEdit" :loading="batchEditDialog.loading">
            保存全部
          </el-button>
        </div>
      </el-dialog>
  
      <!-- 单条新增/编辑弹窗（可选，保留） -->
      <el-dialog
        :title="editDialog.isNew ? '新增记录' : '编辑记录'"
        :visible.sync="editDialog.visible"
        width="700px"
        :close-on-click-modal="false"
        @close="resetEditForm"
      >
        <el-form :model="editDialog.form" label-width="130px" ref="editForm" :rules="editRules">
          <el-form-item label="idsname" prop="idsname">
            <el-input v-model="editDialog.form.idsname" :disabled="!editDialog.isNew" placeholder="唯一标识" />
          </el-form-item>
          <el-form-item label="用户名">
            <el-input v-model="editDialog.form.username" placeholder="请输入用户名" />
          </el-form-item>
          <el-form-item label="别名">
            <el-input v-model="editDialog.form.twoname" placeholder="请输入别名" />
          </el-form-item>
          <el-form-item label="URL">
            <el-input v-model="editDialog.form.url" placeholder="请输入URL" />
          </el-form-item>
          <el-form-item label="曝光URL">
            <el-input v-model="editDialog.form.baoguangurl" placeholder="请输入曝光URL" />
          </el-form-item>
          <el-form-item label="小说URL">
            <el-input v-model="editDialog.form.xiaoshuourl" placeholder="请输入小说URL" />
          </el-form-item>
          <el-form-item label="Token">
            <el-input v-model="editDialog.form.token" placeholder="请输入Token" />
          </el-form-item>
          <el-form-item label="ids">
            <el-input v-model="editDialog.form.ids" placeholder="请输入ids" />
          </el-form-item>
          <el-form-item label="计划名称">
            <el-input v-model="editDialog.form.planName" placeholder="请输入计划名称" />
          </el-form-item>
          <el-form-item label="内置RPK DeepLink">
            <el-input v-model="editDialog.form.builtInRpkDeepLink" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="创意DeepLink">
            <el-input v-model="editDialog.form.adcreativedeeplink" placeholder="请输入" />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="editDialog.visible = false">取消</el-button>
          <el-button type="primary" @click="handleSaveEdit" :loading="editDialog.loading">保存</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { queryByNames, upsertBatchUser, deleteByNames } from '@/api/modules/batchuser'
  import * as XLSX from 'xlsx'
  
  export default {
    name: 'BatchUserIndex',
    data() {
      return {
        loading: false,
        hasQueried: false,
        formData: {
          idsnameText: ''
        },
        tableData: [],               // 查询结果表格数据
        selectedRows: [],            // 勾选的行
        // 批量编辑弹窗
        batchEditDialog: {
          visible: false,
          loading: false,
          data: []                   // 编辑用的副本数据
        },
        editExcelMsg: '',            // 批量编辑Excel导入提示信息
        // 单条新增/编辑弹窗
        editDialog: {
          visible: false,
          isNew: true,
          loading: false,
          form: {
            id: null,
            idsname: '',
            username: '',
            twoname: '',
            url: '',
            baoguangurl: '',
            xiaoshuourl: '',
            token: '',
            ids: '',
            planName: '',
            builtInRpkDeepLink: '',
            adcreativedeeplink: ''
          }
        },
        editRules: {
          idsname: [{ required: true, message: 'idsname不能为空', trigger: 'blur' }]
        }
      }
    },
    methods: {
      // ==================== 工具函数：判断接口是否成功 ====================
      _isSuccess(code) {
        return code === 200 || code === '0' || code === 0
      },
  
      // ==================== 批量查询 ====================
      async handleBatchQuery() {
        const raw = this.formData.idsnameText.trim()
        if (!raw) {
          this.$message.warning('请输入 idsname')
          return
        }
        const idsnames = raw.split('\n').map(s => s.trim()).filter(s => s)
        if (!idsnames.length) {
          this.$message.warning('未识别到有效的 idsname')
          return
        }
        this.loading = true
        this.hasQueried = true
        try {
          const res = await queryByNames(idsnames)
          if (this._isSuccess(res.code)) {
            this.tableData = res.data || []
            this.$message.success('查询成功，共 ' + this.tableData.length + ' 条记录')
          } else {
            this.tableData = []
            this.$message.error(res.msg || '查询失败')
          }
        } catch (e) {
          this.tableData = []
          this.$message.error('网络错误')
        } finally {
          this.loading = false
        }
      },
  
      // 表格选择变化
      handleSelectionChange(val) {
        this.selectedRows = val
      },
  
      // ==================== 批量编辑弹窗 ====================
      handleBatchEdit() {
        if (this.selectedRows.length === 0) {
          this.$message.warning('请先勾选要编辑的数据')
          return
        }
        // 深拷贝勾选行，避免直接修改原表格数据
        this.batchEditDialog.data = this.selectedRows.map(row => Object.assign({}, row))
        this.editExcelMsg = ''
        this.batchEditDialog.visible = true
      },
  
      // 弹窗关闭
      handleBatchEditDialogClose() {
        this.batchEditDialog.data = []
        this.editExcelMsg = ''
      },
  
      // 弹窗内保存全部（循环调用 upsert 接口）
      async handleSaveBatchEdit() {
        this.batchEditDialog.loading = true
        try {
          const promises = this.batchEditDialog.data.map(item => upsertBatchUser(item))
          const results = await Promise.all(promises)
          const allSuccess = results.every(res => this._isSuccess(res.code))
          if (allSuccess) {
            this.$message.success('批量保存成功')
            this.batchEditDialog.visible = false
            // 重新查询刷新主表格
            await this.handleBatchQuery()
          } else {
            this.$message.error('部分保存失败，请检查')
          }
        } catch (e) {
          this.$message.error('网络错误')
        } finally {
          this.batchEditDialog.loading = false
        }
      },
  
      // ==================== 批量编辑弹窗内 Excel 导入填充 ====================
      // 下载编辑模板（包含所有字段列，方便用户填写）
      handleDownloadEditTemplate() {
        const templateData = [
          {
            'idsname': 'nbsqc01',
            '用户名': '三七',
            '别名': '三七',
            'URL': 'https://example.com',
            '曝光URL': '',
            '小说URL': '',
            'Token': '0f35ec162b...',
            'ids': '524cc45734a076a1ef7e',
            '计划名称': '',
            '内置RPK DeepLink': '',
            '创意DeepLink': ''
          }
        ]
        const ws = XLSX.utils.json_to_sheet(templateData)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, '编辑模板')
        ws['!cols'] = [
          { wch: 18 }, { wch: 15 }, { wch: 15 }, { wch: 30 },
          { wch: 35 }, { wch: 35 }, { wch: 40 }, { wch: 25 },
          { wch: 20 }, { wch: 30 }, { wch: 30 }
        ]
        XLSX.writeFile(wb, '批量编辑模板.xlsx')
        this.$message.success('模板下载成功')
      },
  
      // 导入Excel匹配弹窗内的行，并填充字段
      async handleEditExcelImport(file) {
        try {
          const data = await this.readExcelFile(file.raw)
          if (!data || !data.length) {
            this.$message.warning('Excel文件为空')
            return
          }
          // 列名映射（支持中英文表头）
          const COLUMN_MAP = {
            'idsname': 'idsname',
            '用户名': 'username',
            'username': 'username',
            '别名': 'twoname',
            'twoname': 'twoname',
            'URL': 'url',
            'url': 'url',
            '曝光URL': 'baoguangurl',
            'baoguangurl': 'baoguangurl',
            '小说URL': 'xiaoshuourl',
            'xiaoshuourl': 'xiaoshuourl',
            'Token': 'token',
            'token': 'token',
            'ids': 'ids',
            '计划名称': 'planName',
            'planName': 'planName',
            '内置RPK DeepLink': 'builtInRpkDeepLink',
            'builtInRpkDeepLink': 'builtInRpkDeepLink',
            '创意DeepLink': 'adcreativedeeplink',
            'adcreativedeeplink': 'adcreativedeeplink'
          }
  
          let matchedCount = 0
          const editList = this.batchEditDialog.data
  
          // 遍历Excel每一行，根据idsname查找弹窗内对应行并填充
          data.forEach(excelRow => {
            const excelIdsname = excelRow['idsname'] || excelRow['IDSNAME'] || ''
            if (!excelIdsname) return
  
            const targetRow = editList.find(item => String(item.idsname) === String(excelIdsname))
            if (targetRow) {
              Object.keys(excelRow).forEach(key => {
                const mappedKey = COLUMN_MAP[key]
                if (mappedKey && mappedKey !== 'idsname' && targetRow.hasOwnProperty(mappedKey)) {
                  const value = excelRow[key]
                  if (value !== undefined && value !== null && String(value).trim() !== '') {
                    targetRow[mappedKey] = String(value).trim()
                  }
                }
              })
              matchedCount++
            }
          })
  
          const unmatchedCount = data.length - matchedCount
          this.editExcelMsg = `成功匹配 ${matchedCount} 条，${unmatchedCount} 条未找到对应 idsname`
          this.$message.success(`Excel导入完成，匹配 ${matchedCount} 条`)
        } catch (e) {
          console.error(e)
          this.$message.error('Excel文件解析失败')
        }
      },
  
      // ==================== 单条删除 / 批量删除 ====================
      async handleDeleteSingle(row) {
        try {
          await this.$confirm('确定删除 idsname = ' + row.idsname + ' 吗？', '提示', { type: 'warning' })
          const res = await deleteByNames([row.idsname])
          if (this._isSuccess(res.code)) {
            this.$message.success('删除成功')
            this.handleBatchQuery()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        } catch (e) {
          if (e !== 'cancel') this.$message.error('操作取消或失败')
        }
      },
  
      async handleBatchDelete() {
        const names = this.selectedRows.map(row => row.idsname)
        if (!names.length) return
        try {
          await this.$confirm('确定删除选中的 ' + names.length + ' 条记录吗？', '提示', { type: 'warning' })
          const res = await deleteByNames(names)
          if (this._isSuccess(res.code)) {
            this.$message.success(res.msg || '删除成功')
            this.handleBatchQuery()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        } catch (e) {
          if (e !== 'cancel') this.$message.error('操作取消或失败')
        }
      },
  
      // ==================== 单条新增 / 编辑 ====================
      handleAdd() {
        this.editDialog.isNew = true
        this.editDialog.form = {
          id: null,
          idsname: '',
          username: '',
          twoname: '',
          url: '',
          baoguangurl: '',
          xiaoshuourl: '',
          token: '',
          ids: '',
          planName: '',
          builtInRpkDeepLink: '',
          adcreativedeeplink: ''
        }
        this.editDialog.visible = true
        this.$nextTick(() => {
          if (this.$refs.editForm) this.$refs.editForm.clearValidate()
        })
      },
  
      handleEditSingle(row) {
        this.editDialog.isNew = false
        this.editDialog.form = Object.assign({}, row)
        this.editDialog.visible = true
        this.$nextTick(() => {
          if (this.$refs.editForm) this.$refs.editForm.clearValidate()
        })
      },
  
      async handleSaveEdit() {
        const valid = await this.$refs.editForm.validate().catch(() => false)
        if (!valid) return
        this.editDialog.loading = true
        try {
          const res = await upsertBatchUser(this.editDialog.form)
          if (this._isSuccess(res.code)) {
            this.$message.success(res.msg || '保存成功')
            this.editDialog.visible = false
            this.handleBatchQuery()
          } else {
            this.$message.error(res.msg || '保存失败')
          }
        } catch (e) {
          this.$message.error('网络错误')
        } finally {
          this.editDialog.loading = false
        }
      },
  
      resetEditForm() {
        this.editDialog.form = {}
        if (this.$refs.editForm) this.$refs.editForm.resetFields()
      },
  
      // ==================== 主区域 Excel 导入 idsname（前端识别第一列） ====================
      async handleExcelImport(file) {
        try {
          const data = await this.readExcelFile(file.raw)
          if (data && data.length) {
            const names = data.map(row => {
              const firstKey = Object.keys(row)[0]
              return row[firstKey] ? row[firstKey].toString().trim() : ''
            }).filter(v => v && v !== 'idsname' && !v.includes('示例'))
            if (names.length) {
              this.formData.idsnameText = names.join('\n')
              this.$message.success('成功识别 ' + names.length + ' 个 idsname')
            } else {
              this.$message.warning('未识别到有效 idsname')
            }
          } else {
            this.$message.warning('Excel文件为空')
          }
        } catch (e) {
          this.$message.error('解析Excel失败')
        }
      },
  
      // ==================== 下载查询模板（只有 idsname 列） ====================
      handleDownloadTemplate() {
        const templateData = [
          { 'idsname': 'nbsqc01' },
          { 'idsname': 'nbsqc02' }
        ]
        const ws = XLSX.utils.json_to_sheet(templateData)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, '查询模板')
        ws['!cols'] = [{ wch: 20 }]
        XLSX.writeFile(wb, 'idsname查询模板.xlsx')
        this.$message.success('模板下载成功')
      },
  
      // ==================== 通用读Excel文件 ====================
      readExcelFile(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = e => {
            try {
              const data = new Uint8Array(e.target.result)
              const workbook = XLSX.read(data, { type: 'array' })
              const firstSheet = workbook.Sheets[workbook.SheetNames[0]]
              const jsonData = XLSX.utils.sheet_to_json(firstSheet)
              resolve(jsonData)
            } catch (err) {
              reject(err)
            }
          }
          reader.onerror = reject
          reader.readAsArrayBuffer(file)
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .app-container {
    padding: 20px;
  }
  .el-textarea__inner {
    font-family: monospace;
  }
  </style>


// WEBPACK FOOTER //
// src/components/vivo/vivopda/account.vue